import React from "react";
import { GetServerSideProps } from "next";
import ModelSearchPageV2 from "../components/modals/ModelSearchPageV2";

const ModelsPage = (props: { newParam: string; filter: string }) => {
  return <ModelSearchPageV2 />;
};

export default ModelsPage;

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return {
    props: {
      newParam: query.new ?? null,
      filter: query?.filter ?? null,
    },
  };
};
